import Vue from 'vue';
import Router from 'vue-router';
import store from '@/store';

import AdwordsStats from '@/views/AdwordsStats.vue';
import PurchaseDomain from '@/views/PurchaseDomain.vue';
import QLPStats from '@/views/QLPStats.vue';
import TransferDomain from '@/views/TransferDomain.vue';

import FourOhFour from '@/views/FourOhFour.vue';
import FourOhThree from '@/views/FourOhThree.vue';

import ApprovalQueue from '@/views/admin/ApprovalQueue.vue';

import EmptyRouterView from '@/views/EmptyRouterView';

Vue.use(Router);

let router = new Router({
    mode: 'history',
    routes: [
        {
            path: '/domains',
            component: EmptyRouterView,
            meta: { name: 'Domains', ignoreBreadcrumb: true },

            children: [
                {
                    path: '',
                    redirect: '/',
                    meta: { ignoreBreadcrumb: true },
                },
                {
                    path: 'purchase',
                    component: PurchaseDomain,
                    meta: { name: 'Purchase Domain' },
                },
                {
                    path: 'transfer',
                    component: TransferDomain,
                    meta: { name: 'Transfer Domain' },
                },
            ],
        },
        {
            path: '/qlp',
            component: QLPStats,
            beforeEnter: requireNotIntern,
            meta: { name: 'Landing Pages' },
        },
        {
            path: '/adwords',
            component: AdwordsStats,
            beforeEnter: requireNotIntern,
            meta: { name: 'Google Ads' },
        },
        {
            path: '/403',
            component: FourOhThree,
            meta: {
                restricted: true,
                hideBreadcrumbs: true,
            },
        },
        {
            path: '/admin',
            meta: { name: 'Admin', ignoreBreadcrumb: false },
            component: EmptyRouterView,
            children: [
                {
                    path: 'approvalqueue',
                    component: ApprovalQueue,
                    beforeEnter: requireAdmin,
                    meta: {
                        name: 'Approval Queue',
                        restricted: true,
                        dumb: true,
                    },
                },
            ],
        },

        {
            path: '*',
            component: FourOhFour,
            meta: {
                hideBreadCrumbs: true,
                dumb: true,
                restricted: true,
            },
        },
    ],
});

router.afterEach(() => {
    // check if there is a new version of the app
    // refresh if there's a new version
    if (store.getters.newVersion) {
        store.commit('update_app');
    }
});

async function waitForUser() {
    return new Promise((resolve) => {
        if (store.getters.user()) {
            resolve(store.getters.user());
        } else {
            store.dispatch('get_user_bundle');
            store.watch(store.getters.user, function () {
                return resolve(store.getters.user());
            });
        }
    });
}

async function waitForAccountAgencyType() {
    return new Promise((resolve) => {
        if (store.getters.account_agency_type()) {
            resolve(store.getters.account_agency_type());
        } else {
            store.dispatch('get_account_bundle');
            store.watch(store.getters.account_agency_type, function () {
                return resolve(store.getters.account_agency_type());
            });
        }
    });
}

async function requireNotIntern(to, from, next) {
    await waitForUser();
    let agency_type = await waitForAccountAgencyType();
    if (agency_type !== 'Mirus Intern') {
        return next();
    } else {
        return next('/');
    }
}

async function requireAdmin(to, from, next) {
    let user = await waitForUser();
    if (user.user_type === 'MirusEmployee') {
        return next();
    } else {
        return next('/');
    }
}

export default router;
